import React from "react";
import Link from "next/link";
import { Box } from "@mantine/core";

const MenuItemLink = ({
  href,
  icon: Icon,
  label,
  iconColor = "#3f4a54",
  textColor = "#162238",
  external = false,
  onClick,
}) => {
  const content = (
    <Box
      component="a"
      rel={external ? "noopener noreferrer" : undefined}
      href={external ? href : undefined}
      c={textColor}
      display="flex"
      fw={500}
      td="none"
      onClick={onClick}
    >
      {Icon && <Icon color={iconColor} size={20} style={{ marginRight: 8 }} />}
      {label}
    </Box>
  );

  if (external) {
    return content;
  }

  return (
    <Link legacyBehavior href={href ?? "/"} passHref>
      {content}
    </Link>
  );
};

export default MenuItemLink;
